module.exports = __webpack_public_path__ + "img/common_icon_machine.63523717.png";